export default __webpack_public_path__ + "9f999e3032a4997eb2493f87b43224aa.png";